<template>
  <section class="agenda tuesday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Wednesday, May 28th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:00 AM</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                Lunch
              </p>
              <div class="cards__description">
                <p>12:30 PM - 2:30 PM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in morningSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
            <div class="cards__single cryptoknights noheight">
              <p class="cards__title">
                <a href="https://www.cryptoknights.tv/" target="_blank">
                  <img src="@/assets/logos/cryptoknights.png" alt="Crypto Knights Logo" class="ck">
                </a>
              </p>
              <div class="cards__description">
                <p>5:30 PM - 6:30 PM</p>
              </div>
            </div>
                        <div v-for="(speaker, index) in eveningSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 8:00 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Supper Club
              </p>
              <div class="cards__description">
                <p>8:00 PM - 10:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      morningSet: [
        {
          imgClass: 'adams',
          name: 'Eric Adams',
          title: '110th Mayor of New York City',
          time: '12:00 PM - 12:30 PM'
        },
        {
          imgClass: 'johnson',
          name: 'Bryan Johnson',
          title: 'Founder - Blueprint',
          time: '2:30 PM - 3:00 PM'
        },
        {
          name: 'Catching looks: Entertainment & Web3',
          title: 'Moderator: Jake Flaherty - Director of Advisory Services, DNA<br>CryptoKnight’s<br>Idon Liu - Pentagon Games<br>Mauricio Silvestris - Backstage Global<br>Jack Jay - Persist Ventures',
          time: '3:00 PM - 3:20 PM',
          class: 'noheight panel'
        },
        {
          name: 'The Future of Utility Across Blockchains',
          title: 'Moderator: Rick Schlesinger, DNA Venture Partner<br>Dr. K - Co-Founder, Quai Network<br>Robert Hirsch, Ph.D - CEO, Zkalyx<br>Edan Yago - CEO & Co-Founder, BitcoinOS',
          time: '3:30 PM - 4:00 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'mahmood',
          name: 'Naeem Mahmood',
          title: 'Founder - Peak3',
          time: '4:00 PM - 4:20 PM'
        },
        {
          name: 'Reshaping the AI landscape',
          title: 'Moderator: J.D. Seraphine - Founder & CEO, Raiinmaker<br>Michal “Mehow” Pospieszalski - CEO & Co-Founder, Matterfi<br>JD Seraphine - Founder & CEO, Raiinmaker<br>Tony Evans - Co-Founder, CETI AI and RATE Group',
          time: '4:20 PM - 4:50 PM',
          class: 'noheight panel'
        },
        {
          name: 'DeFi Around the World: How DeFi is Enabling Users From All Over to Take Control of Their Finances',
          title: 'Moderator: JR Pasch - Asset Management, DNA<br>David Aw - CEO, Inbestgo<br>Ryan DiRocco - Board Advisor, Monoquant<br>Adeola Adedewe - CEO & Founder, Kredete<br>Toby Gilbert - Co-Founder, Pact Swap<br>Ian Caldwell - Director of Business Development, Monoquant',
          time: '4:50 PM - 5:30 PM',
          class: 'noheight panel'
        }
      ],
      eveningSet: [
        {
          imgClass: 'adams',
          name: 'Eric Adams',
          title: '110th Mayor of New York City',
          time: '6:30 PM - 7:00 PM'
        }
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
